export const BeginTrackingCookie = 'may-begin-collection-of-data';
export const ConsentBannerAcceptedCookie = 'user-has-accepted-consent-banner';

function escapeRegular(str: string) {
  return str.replace(/[.*+?^$|[\](){}\\-]/g, '\\$&');
}

export function getCookie(key: string, decoder = decodeURIComponent) {
  if ((typeof key !== 'string') || !key) {
    return null;
  }
  const reKey = new RegExp(`(?:^|; )${escapeRegular(key)}(?:=([^;]*))?(?:;|$)`);
  const match = reKey.exec(document.cookie);

  if (match === null) {
    return null;
  }

  return typeof decoder === 'function' ? decoder(match[1]) : match[1];
}

export function setCookie(name: string, value: number, expiryDays: number, domain: string, path: string) {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + (expiryDays || 365));

  const cookie = [
    `${name}=${value}`,
    `expires=${expirationDate.toUTCString()}`,
    `path=${(path || '/')}`,
  ];

  if (domain) {
    cookie.push(`domain=${domain}`);
  }

  document.cookie = cookie.join(';');
}
